import { useBoolean } from 'minimal-shared/hooks';

import { IconButton, InputAdornment } from '@mui/material';

import { Field } from './fields';
import { Iconify } from '../iconify';

export function Password({ name = 'password', label = 'Password' }) {
  const showPassword = useBoolean();

  return (
    <Field.Text
      name={name}
      label={label}
      placeholder="6+ characters"
      type={showPassword.value ? 'text' : 'password'}
      slotProps={{
        htmlInput: {
          'data-testid': 'password',
        },
        inputLabel: { shrink: true },
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={showPassword.onToggle}
                edge="end"
                data-testid="AuthTogglePasswordVisibility"
              >
                <Iconify icon={showPassword.value ? 'solar:eye-bold' : 'solar:eye-closed-bold'} />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
